import React, { useState, useEffect } from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Link } from 'react-router-dom';
import DomoticNavbar from '../Components/Navbar';
import "../Components/navbar.css";
import "./ryn.css";
import ryn1 from "./img-domotic/networkingyredes.png";
import ryn2 from "./img-domotic/networkingyredes2.png";


import fortinet from "./img_marcas/fortinet.png"


const RedesNetworking = () => {
  const [showMenu, setShowMenu] = useState(false);

  // Datos específicos para Redes y Networking
  const imagenesGaleria = [
    { src: ryn1, alt: "Infraestructura de red empresarial", caption: "Redes empresariales escalables" },
    { src: ryn2, alt: "Solución de cableado estructurado", caption: "Cableado estructurado certificado" }
  ];

  const servicios = [
    {
      icon: "🌐",
      titulo: "Diseño de infraestructura",
      descripcion: "Soluciones personalizadas para redes cableadas e inalámbricas empresariales con arquitectura escalable.",
      features: ["Análisis de necesidades", "Topología optimizada", "Documentación técnica"]
    },
    {
      icon: "🔒",
      titulo: "Seguridad de redes",
      descripcion: "Protección avanzada contra amenazas con firewalls de última generación y sistemas de detección de intrusos.",
      features: ["Firewalls empresariales", "VPN seguras", "Monitoreo 24/7"]
    },
    {
      icon: "🛠️",
      titulo: "Monitoreo y mantenimiento",
      descripcion: "Solución proactiva con herramientas enterprise para garantizar máximo rendimiento y disponibilidad.",
      features: ["Alertas tempranas", "Reports mensuales", "SLA 99.9%"]
    },
    {
      icon: "🔌",
      titulo: "Cableado estructurado",
      descripcion: "Implementación profesional de categoría 6A/7 con certificación y garantía extendida.",
      features: ["Certificación TIA-568", "Garantía 25 años", "Pruebas de rendimiento"]
    }
  ];

  const tiposSoluciones = [
    {
      categoria: "Redes Empresariales",
      items: [
        "Arquitectura SD-WAN",
        "Redes definidas por software",
        "Conectividad multi-site"
      ]
    },
    {
      categoria: "Conectividad Inalámbrica",
      items: [
        "WiFi 6 Enterprise",
        "Sistemas mesh",
        "Control de acceso por roles"
      ]
    },
    {
      categoria: "Centros de Datos",
      items: [
        "Virtualización de redes",
        "Balanceo de carga",
        "Redundancia carrier-grade"
      ]
    }
  ];

  const marcas = [
    { nombre: "Cisco", logo: "/marcas/cisco.png" },
    { nombre: "Ubiquiti", logo: "/marcas/ubiquiti.png" },
    { nombre: "Fortinet", logo: {fortinet} },
    { nombre: "Aruba", logo: "/marcas/aruba.png" },
    { nombre: "MikroTik", logo: "/marcas/mikrotik.png" },
    { nombre: "Huawei", logo: "/marcas/huawei.png" }
  ];

  // Efecto de scroll reveal
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.ryn-scroll-reveal').forEach(el => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="ryn-container">
      <DomoticNavbar/>
      
      {/* Hero Section */}
      <section className="ryn-hero">
        <div className="ryn-hero-content">
          
          <p className="ryn-hero-subtitle">
            Redes y Networking
          </p>
        </div>
      </section>

      {/* Galería de Imágenes (lado a lado) */}
      <section className="ryn-gallery ryn-scroll-reveal">
        {imagenesGaleria.map((img, index) => (
          <div key={index} className="ryn-gallery-item">
            <img 
              src={img.src} 
              alt={img.alt}
              className="ryn-gallery-img"
            />
            <div className="ryn-gallery-caption">
              <p>{img.caption}</p>
            </div>
          </div>
        ))}
      </section>

    {/* Sección de Características con Imágenes de Fondo */}
<section className="ryn-features-section">
  <div className="ryn-features-container">
    <h2 className="ryn-features-title">Nuestras Soluciones de Redes</h2>
    <p className="ryn-features-subtitle">Tecnología avanzada para conectividad empresarial</p>
    
    <div className="ryn-features-grid">
      {/* Característica 1 */}
      <div className="ryn-feature-card">
        <div className="ryn-feature-content">
          <h3 className="ryn-feature-title">SISTEMAS DE TELECOMUNICACIONES Y REDES</h3>
          <ul className="ryn-feature-list">
            <li>Centrales Telefónicas: análogas y telefonía IP</li>
            <li> Routers, Access point, antenas para enlace inalámbricos</li>
            <li>Networking y Redes con las mejores marcas del mercado</li>
          </ul>
        </div>
      </div>
      
     
    </div>
  </div>
</section>  



    </div>
  );
};

export default RedesNetworking;